import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearAllFilters,
  getRows,
  inputSearch,
  removeAllRows,
  setFields,
  setfiltersResetDefault,
  sort
} from 'features/GridSlice';
import { selectView } from 'features/GeneralSlice';

import './SavedViews.scss';

export function SavedViews(props: any) {
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const { viewSelected } = useSelector((state: any) => state.general);

  const history = useHistory();

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    return () => {
      dispatch(selectView(-1));
    };
  }, [dispatch]);

  const isEdited = (path: string) => {
    const _isEdited =
      decodeURI(path.replaceAll("'", '"')) !==
      decodeURI(
        window.location.pathname + window.location.search.replace(/&group=.*&/, '&').replace(/&account=.*&/, '&')
      );
    props.onEdit(_isEdited);
    return _isEdited;
  };

  const viewOnClick = (path: string, index: number) => {
    if (viewSelected === index) {
      return;
    }

    dispatch(sort(''));
    dispatch(clearAllFilters());
    dispatch(inputSearch(''));
    dispatch(setFields([]));
    // dispatch(setGlobalFilter(''));
    dispatch(selectView(index));
    history.push(path.replaceAll("'", '"'));
  };

  const backToDefault = (ev: React.MouseEvent<HTMLElement>) => {
    if (viewSelected < 0) {
      return;
    }
    dispatch(selectView(-1));
    dispatch(setfiltersResetDefault(true));
    dispatch(removeAllRows());
    dispatch(getRows());
    dispatch(clearAllFilters());
    props.onEdit(false);
    history.push(props.data[props.page][props.tab].default.replaceAll("'", '"'));
  };

  const resetOnClick = (view: any) => (ev: React.MouseEvent<HTMLElement>) => {
    ev.stopPropagation();
    dispatch(removeAllRows());
    props.onEdit(false);
    history.push(view.path.replaceAll("'", '"'));
  };

  if (!props.data[props.page] || !props.data[props.page][props.tab]) {
    return null;
  }

  return (
    <div
      className={classNames('SavedViews', {
        open: open
      })}
    >
      <div className="header">
        <span>Saved Views</span>
        <span className={viewSelected > -1 ? 'active' : ''} onClick={backToDefault}>
          Clear View
        </span>
      </div>
      <div className="scrollbar-common">
        <div className="layer">
          <ul className={classNames({ open: open })}>
            {props.data[props.page][props.tab].views.map((view: any, index: number) => {
              return (
                <li
                  key={index}
                  onClick={() => viewOnClick(view.path, index)}
                  className={classNames({ selected: viewSelected === index })}
                >
                  <div className="view-content-wrapper">
                    <div>
                      <img className="icon" src={`/assets/images/logo-ionix.svg`} alt="Ionix" />
                    </div>
                    <div>{view.label}</div>
                  </div>
                  {viewSelected === index && isEdited(view.path) && (
                    <div className="buttons">
                      {viewSelected === index && isEdited(view.path) && <div className="edited-badge">Edited</div>}
                      <span className="reset" onClick={resetOnClick(view)}>
                        Reset
                      </span>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
